// extracted by mini-css-extract-plugin
export default {"formWrapper":"_iBiJTQfoD9XeRPwDqJw","saveButton":"svfTrkomLRldzIoq00Ug"};